import React, { Fragment } from "react";
import { Loading } from "./Loading";
import axios from "axios";

import { connect } from "react-redux";
import {createUser, loadStatus, logOutUser} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BASE_URL } from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import {NetworkError} from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Khidmate_e_khalq extends React.Component {
  constructor() {
    super();
    this.state = {
      rishtanata: 0,
      widows: 0,
      unmarried: 0,
      aids: 0,
      first_aid: 0,
      medical_camp: 0,
      b_donation: 0,
      elder: 0,
      orphan: 0,
      clinics: 0,
      khudam: 0,
      hygiene: 0,
      aqiqah: 0,
      nikah: 0,
      janaza: 0,
      walimot: 0,
      special: 0,
      house: 0,
      car: 0,
      on_duty: 0,
      phone: "",
      isSubmitting: false,
      submitted: false,
      loading: true,
      modal: false,
      month: 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // mod.modal('show');
    document.title = "KHIDMAT E KHALQ - MKAN REPORT";
    this.setupValidator();
  }
  setupValidator() {
    this.setState({
      loading: false
    });
    const {year, month} = this.props.monthYear;
    const {failed} = this.props.status;
    if (failed) {
      this.props.loadStatus(month, year);
    }
    this.validator = new SimpleReactValidator();
  }



  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    const { month, year, monthName } = this.props.monthYear;
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      return;
    }
    Swal.fire({
      title:
        "Are you sure you want to submit your KHIDMAT E KHALQ report for " +
        monthName +
        " " +
        year +
        "?",
      text:
        "You won't be able to revert this after submitting, kindly check all details are accurate.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33"
    }).then(result => {
      if (result.value) {
        this.setState({
          isSubmitting: true
        });
        console.log(result);

        this.LoadingBar.continousStart();

        http
          .post(
            endpoints.SOCIAL,
            {
              rishtanata: this.state.rishtanata,
              widows: this.state.widows,
              unmarried: this.state.unmarried,
              aids: this.state.aids,
              first_aid: this.state.first_aid,
              medical_camp: this.state.medical_camp,

              b_donation: this.state.b_donation,
              elder: this.state.elder,
              orphan: this.state.orphan,
              clinics: this.state.clinics,
              khudam: this.state.khudam,
              aqiqah: this.state.aqiqah,
              nikah: this.state.nikah,
              janaza: this.state.janaza,
              walimot: this.state.walimot,
              special: this.state.special,
              house: this.state.house,
              car: this.state.car,
              hygiene: this.state.hygiene,
              on_duty: this.state.on_duty,
              phone: this.state.phone,
              month: month,
              year: year
            },
          )
          .then(res => {

            if (res.status !== 201) {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "warning",
                title: "There is an error in your submission, try again"
              });
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "success",
                title: " KHIDMAT-E-KHALQ report submitted successfully "
              });

              this.LoadingBar.complete();
              this.setState({
                isSubmitting: false,
                modal: true,
              });
              this.props.loadStatus(month,year);
            }
          })
            .catch(error => {
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
              let errorMessage =
                  (typeof error === "string" && error) ||
                  "An error occured, please try again in a moment.";

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: errorMessage
              });
              // alert(JSON.stringify(error));
              console.log(errorMessage);
            });
      }
    });
  }
  render() {
    const {year, monthName} = this.props.monthYear;
    const {data, isFetching, failed} = this.props.status;
    const {isSubmitting} = this.state;
    return (
        <div>
          {failed ? (
              <NetworkError />
          ) : (
      <section className="content">
        {this.state.loading || isFetching ? (
          <div>
            <div className="spinner">
              <Loader type="ThreeDots" color="#00BFFF" height="40" width="40" />
            </div>
          </div>
        ) : (
          <div>
            {!data.social ? (
              <div>
                <LoadingBar onRef={ref => (this.LoadingBar = ref)} />

                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header card-header-primary">
                        <h4 className="card-title">
                          KHIDMAT-E-KHALQ(WELFARISM) - {monthName},{" "}
                          {year}
                        </h4>
                        <p className="card-category">Complete the form below</p>
                      </div>

                      <div className="card-body">
                        <form onSubmit={this.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  No. of Khuddam involved in Rishtanata
                                  activities
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="rishtanata"
                                  name="rishtanata"
                                  value={this.state.rishtanata}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              {this.validator.message(
                                "rishtanata",
                                this.state.rishtanata,
                                "required"
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  No. of widows
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="widows"
                                  name="widows"
                                  value={this.state.widows}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              {this.validator.message(
                                "widows",
                                this.state.widows,
                                "required"
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  No. of unmarried khuddam (from ages 24)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="unmarried"
                                  name="unmarried"
                                  value={this.state.unmarried}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              {this.validator.message(
                                "unmarried",
                                this.state.unmarried,
                                "required"
                              )}
                            </div>
                          </div>
                          <div className="row myborder">
                            <div className="col-md-12 mycenter">
                              <h2>Social Welfare Activities</h2>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Aids(Poor nd indigents)
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="aids"
                                  min="0"
                                  name="aids"
                                  value={this.state.aids}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "aids",
                                  this.state.aids,
                                  "required"
                                )}
                              </span>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  First Aid
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="first_aid"
                                  name="first_aid"
                                  value={this.state.first_aid}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "first aid",
                                  this.state.first_aid,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Medical Camp
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="medical_camp"
                                  name="medical_camp"
                                  value={this.state.medical_camp}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "medical camp",
                                  this.state.medical_camp,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Blood donation
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="b_donation"
                                  name="b_donation"
                                  value={this.state.b_donation}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "blood donation",
                                  this.state.b_donation,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Visit to elders
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="elder"
                                  name="elder"
                                  value={this.state.elder}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "elder",
                                  this.state.elder,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Visit to Orphanage
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="orphan"
                                  name="orphan"
                                  value={this.state.orphan}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "orphan",
                                  this.state.orphan,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Visit to clinics/hospitals
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="clinics"
                                  name="clinics"
                                  value={this.state.clinics}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "clinics",
                                  this.state.clinics,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Visit to Khuddam
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="khudam"
                                  name="khudam"
                                  value={this.state.khudam}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "visit to khuddam",
                                  this.state.khudam,
                                  "required"
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 mt-3">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  How many meetings on importance of Physical
                                  Hygiene’
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="hygiene"
                                  name="hygiene"
                                  value={this.state.hygiene}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "hygiene",
                                  this.state.hygiene,
                                  "required"
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="row myborder">
                            <div className="col-md-12 mycenter">
                              <h2>No. of Ceremonial Activities </h2>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Aqiqah
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="aqiqah"
                                  name="aqiqah"
                                  value={this.state.aqiqah}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "aqiqah",
                                  this.state.aqiqah,
                                  "required"
                                )}
                              </span>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Nikkah
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="nikah"
                                  name="nikah"
                                  value={this.state.nikah}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "nikah",
                                  this.state.nikah,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Janaza
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="janaza"
                                  name="janaza"
                                  value={this.state.janaza}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "janaza",
                                  this.state.janaza,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Walimot/Aminu Quran
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="walimot"
                                  name="walimot"
                                  value={this.state.walimot}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "walimot",
                                  this.state.walimot,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  House warming
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="house"
                                  name="house"
                                  value={this.state.house}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "house warming",
                                  this.state.house,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Car warming
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="car"
                                  name="car"
                                  value={this.state.car}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "car warming",
                                  this.state.car,
                                  "required"
                                )}
                              </span>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  No of khuddam on duty
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  id="on_duty"
                                  name="on_duty"
                                  value={this.state.on_duty}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "duty",
                                  this.state.on_duty,
                                  "required"
                                )}
                              </span>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="bmd-label-floating">
                                  Nazim Khidmat Khalq's phone number
                                </label>

                                <input
                                  type="tel"
                                  className="form-control"
                                  name="phone"
                                  value={this.state.phone}
                                  onChange={this.handleChange}
                                />
                              </div>
                              <span className="text-danger">
                                {this.validator.message(
                                  "Nazim Khidmat Khalq's phone number",
                                  this.state.phone,
                                  "required|min:5|max:11"
                                )}
                              </span>
                            </div>
                          </div>

                          {isSubmitting ? <Loading /> : ""}

                          <button
                            type="submit"
                            className="btn btn-success pull-right"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Loading..." : "Submit"}
                          </button>
                          <div className="clearfix" />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div />
              </div>
            ) : (
              <div className="d-flex align-items-center">
                <h2>
                  You already submitted KHIDMAT E KHALQ report for{" "}
                  <b>
                    {monthName}, {year}
                  </b>
                </h2>
              </div>
            )}
          </div>
        )}
      </section>
          )}
        </div>
          );
  }
}

Khidmate_e_khalq.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status,
});

export default connect(mapStateToProps, { createUser, logOutUser, loadStatus })(
  Khidmate_e_khalq
);
